export const firebaseConfig = {
  apiKey: "AIzaSyBsLa1nCc8yvLtMbPF-lzki6oj0voO9xYE",

  authDomain: "mahjongpak.firebaseapp.com",

  databaseURL: "https://mahjongpak.firebaseio.com",

  projectId: "mahjongpak",

  storageBucket: "mahjongpak.appspot.com",

  messagingSenderId: "315355388350",

  appId: "1:315355388350:web:4acc5b3af19e19d366c1ef",
};
